export default __webpack_public_path__ + "static/media/gallery2.e38ede82.PNG";